import type { SVGProps } from "react";

const Component = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 8 16" {...props}>
    <path
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      d="M.292 16.148a.575.575 0 0 1-.033-.81l6.469-7.04-6.47-7.05a.56.56 0 0 1 .034-.8c.232-.22.592-.2.806.03l6.858 7.43c.203.22.203.55 0 .77l-6.858 7.43a.576.576 0 0 1-.806.04"
    />
  </svg>
);
export default Component;
